/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Material Dashboard 2 PRO React components
import MDInput from 'components/MDInput';
import MDBox from 'components/MDBox';
import { Icon } from '@mui/material';

function FormMarkup({ parent, edit }) {
  const [attr, setAttr] = useState(parent);
  const [markupChange, setMarkupChange] = useState(parent.markup);

  const send = () => {
    if (attr.markup !== markupChange) {
      setMarkupChange(attr.markup);
      edit({ id: attr.id, markup: attr.markup }, 'MARKUP');
    }
  };

  return (
    <MDBox
      noValidate
      component='form'
      role='form'
      onSubmit={(e) => {
        e.preventDefault();

        send();
      }}
    >
      <MDInput
        value={attr.markup}
        type='number'
        onChange={(e) => setAttr({ ...attr, markup: e.target.value })}
        onFocus={(e) => {
          e.target.select();
        }}
        onBlur={() => {
          send();
        }}
        variant='standard'
        fullWidth
        InputProps={{
          inputProps: {
            maxLength: 20,
            autoComplete: 'off',
            className: 'text-right',
            sx: { minWidth: 80 },
          },
          endAdornment: <Icon color='info'>percent</Icon>,
        }}
      />
    </MDBox>
  );
}

FormMarkup.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    markup: PropTypes.string.isRequired,
  }).isRequired,
  edit: PropTypes.func.isRequired,
};

export default FormMarkup;
